// extracted by mini-css-extract-plugin
export var grid = "fp-tV";
export var gridWithRowGap = "fp-uV";
export var maxWidthContainer = "fp-yV";
export var mt0 = "fp-lV";
export var mt1 = "fp-mV";
export var mt2 = "fp-nV";
export var mt3 = "fp-oV";
export var mt4 = "fp-pV";
export var mt5 = "fp-qV";
export var mt6 = "fp-rV";
export var navigationDropdown = "fp-zV";
export var navigationDropdownExpanded = "fp-DV";
export var navigationDropdown__btn = "fp-sV";
export var navigationDropdown__btnWrapper = "fp-AV";
export var navigationDropdown__items = "fp-GV";
export var navigationDropdown__itemsCaret = "fp-FV";
export var navigationDropdown__itemsWrapper = "fp-EV";
export var navigationDropdown__leftIcon = "fp-BV";
export var navigationDropdown__rightIcon = "fp-CV";
export var removeVisuallyHidden = "fp-wV";
export var visuallyHidden = "fp-vV";
export var widgetBase = "fp-xV";